'use client';

import Link from 'next/link';
import { ChevronLeft } from 'lucide-react';
import styles from './PricingSectionV2.module.css';

interface DetailBackLinkProps {
  href?: string;
  onClick?: () => void;
  className?: string;
}

export default function DetailBackLink({ href = '/#pricing', onClick, className }: DetailBackLinkProps) {
  const content = (
    <>
      <ChevronLeft size={18} aria-hidden="true" />
      Back
    </>
  );

  if (onClick) {
    return (
      <button type="button" className={`${styles.detailBackLink} ${className ?? ''}`.trim()} onClick={onClick}>
        {content}
      </button>
    );
  }

  return (
    <Link href={href} className={`${styles.detailBackLink} ${className ?? ''}`.trim()}>
      {content}
    </Link>
  );
}
